import { useContext } from 'react';

import { IntlProviderContext } from '../Contexts/IntlProviderContext';

const useIntlProvider = () => {
  return useContext(IntlProviderContext);
};

export default useIntlProvider;
